// hooks/admin/property/usePropertyManagement.js

import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

import {
  getAllProperties,
  createProperty,
  updateProperty,
  deleteProperties,
  uploadPropertyImages
} from "../../../services/propertyService";

import { getAllProjects } from "../../../services/projectService";

export const usePropertyManagement = () => {
  const [properties, setProperties] = useState([]);
  const [projects, setProjects] = useState([]);

  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const loadProperties = useCallback(async () => {
    try {
      setLoading(true);

      const res = await getAllProperties(
        filters,
        page,
        10
      );

      setProperties(res?.properties || []);
      setTotalPages(res?.totalPages || 1);
    } catch (error) {
      toast.error(
        "Không thể tải danh sách bất động sản"
      );
    } finally {
      setLoading(false);
    }
  }, [filters, page]);

  const loadProjects = useCallback(async () => {
    try {
      const res = await getAllProjects();

      setProjects(res?.projects || []);
    } catch (error) {
      toast.error(
        "Không thể tải danh sách dự án"
      );
    }
  }, []);

  useEffect(() => {
    loadProperties();
  }, [loadProperties]);

  useEffect(() => {
    loadProjects();
  }, [loadProjects]);

  const create = async (payload) => {
    await createProperty(payload);
    await loadProperties();
  };

  const update = async (id, payload) => {
    await updateProperty(id, payload);
    await loadProperties();
  };

  const remove = async (id) => {
    await deleteProperties(id);
    await loadProperties();
  };

  return {
    properties,
    projects,

    loading,

    filters,
    setFilters,

    page,
    setPage,

    totalPages,

    create,
    update,
    remove,
    uploadPropertyImages,

    refresh: loadProperties,
  };
};